<template>
    <article>
        <div style="max-width: 770px;">
            <div class="breadcrumbs p14 mb-5">
                <router-link to="/">Home</router-link> &raquo; <a href="#">Unsubscribe</a>
            </div>
            
            <div class="mb-5">
                <p class="light"></p>
                <div class="row">
                    <div class="col-lg-6 mb-3 mb-lg-0">
                        <div class="card bg-grey">
                            <div class="card-body text-center">
                                <h4 class="mb-3">Unsubscribe Email</h4>
                                <router-link to="/unsubscribe/email" class="btn btn-secondary uc">Choose</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-3 mb-lg-0">
                        <div class="card bg-grey">
                            <div class="card-body text-center">
                                <h4 class="mb-3">Unsubscribe Phone</h4>
                                <router-link to="/unsubscribe/phone" class="btn btn-secondary uc">Choose</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p14 text-right"><router-link to="/">Return Home</router-link></div>
        </div>
    </article>
</template>

<script>

export default {
    name: "UnsubscribeIndex", 
}
</script>

<style>

</style>

